import { useEffect, useState } from 'react'
import ConfiguratorBack from './ConfiguratorBack.js'
import SectionButton from './SectionButton.js'
import SectionGender from './SectionGender.js'
import SectionSkin from './SectionSkin.js'
import SectionBasic from './SectionBasic.js'


export default function Configurator({ data, avatarLoader }) {
    const [ skins, setSkins ] = useState([]);
    const [ section, setSection ] = useState('gender');

    const [ gender, setGender ] = useState(Math.random() > 0.5 ? 'female' : 'male');
    const [ skin, setSkin ] = useState(Math.ceil(Math.random() * 7));
    const [ head, setHead ] = useState(null);
    const [ hair, setHair ] = useState(null);
    const [ top, setTop ] = useState(null);
    const [ topSecondary, setTopSecondary ] = useState(null);
    const [ bottom, setBottom ] = useState(null);
    const [ bottomSecondary, setBottomSecondary ] = useState(null);
    const [ shoes, setShoes ] = useState(null);

    const setters = {
        head: setHead,
        hair: setHair,
        top: setTop,
        bottom: setBottom,
        shoes: setShoes
    };

    const settersSecondary = {
        top: setTopSecondary,
        bottom: setBottomSecondary,
    };

    const randomAll = () => {
        Object.keys(setters).forEach(key => randomSlot(key));
    };

    const randomSlot = (slot) => {
        const list = data.genders[gender][slot].list;
        const item = list[Math.floor(Math.random() * list.length)];
        let url = item.file;
        if (slot === 'head') url += '_' + (skin + '').padStart(2, '0');
        setters[slot](url);

        if (settersSecondary[slot])
            settersSecondary[slot](item.secondary ?? null);
    };

    useEffect(() => {
        window.app?.fire('camera:slotFocus', section);
    }, [ section ]);

    useEffect(() => {
        setSkins(data.skin);
    }, []);

    useEffect(() => {
        randomAll();
    }, [gender]);

    useEffect(() => {
        if (head) {
            const headNew = head.replace(/_[0-9]{2}$/, '_' + ((skin + '').padStart(2, '0')));
            setHead(headNew);
        } else {
            randomSlot('head');
        }
    }, [skin]);

    useEffect(() => {
        avatarLoader.setGender(gender);
        avatarLoader.setSkin(skin);
        if (head) avatarLoader.load('head', head + '.glb');
        if (hair) avatarLoader.load('hair', hair + '.glb');
        if (top) avatarLoader.load('top', top + '.glb');
        if (topSecondary) avatarLoader.load('top:secondary', topSecondary + '.glb');
        if (bottom) avatarLoader.load('bottom', bottom + '.glb');
        if (bottomSecondary) avatarLoader.load('bottom:secondary', bottomSecondary + '.glb');
        if (shoes) avatarLoader.load('shoes', shoes + '.glb');
    }, [avatarLoader]);

    useEffect(() => { if (!avatarLoader) return; avatarLoader.setGender(gender); }, [gender]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.setSkin(skin); }, [skin]);

    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('head', head ? (head + '.glb') : null); }, [head]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('hair', hair ? (hair + '.glb') : null); }, [hair]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('top', top ? (top + '.glb') : null); }, [top]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('top:secondary', topSecondary ? (topSecondary + '.glb') : null); }, [topSecondary]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('bottom', bottom ? (bottom + '.glb') : null); }, [bottom]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('bottom:secondary', bottomSecondary ? (bottomSecondary + '.glb') : null); }, [bottomSecondary]);
    useEffect(() => { if (!avatarLoader) return; avatarLoader.load('shoes', shoes ? (shoes + '.glb') : null); }, [shoes]);

    return (
        <div className='configurator'>
            <ConfiguratorBack />

            <h2>Customise{/* <span className='random' onClick={randomAll}></span>*/}</h2>

            <div className='main'>
                <ul className='sections' onTouchMove={(evt) => { evt.stopPropagation(); }}>
                    <SectionButton slot='gender' setSection={setSection} active={section === 'gender'} icon={`/img/thumbnails/gender_${gender}.webp`} className='skin' />
                    <SectionButton slot='head' setSection={setSection} active={section === 'head'} />
                    <SectionButton slot='hair' setSection={setSection} active={section === 'hair'} />
                    <SectionButton slot='top' setSection={setSection} active={section === 'top'} />
                    <SectionButton slot='bottom' setSection={setSection} active={section === 'bottom'} />
                    <SectionButton slot='shoes' setSection={setSection} active={section === 'shoes'} />
                </ul>

                <div className='items' onTouchMove={(evt) => { evt.stopPropagation(); }}>
                    {section === 'gender' && <SectionGender gender={gender} setGender={(value) => { setGender(value); }} />}
                    {section === 'gender' && <SectionSkin skin={skin} skins={skins} setSkin={(value) => { setSkin(value); }} />}
                    {section === 'head' && <SectionBasic slot='head' title='Head' data={data} gender={gender} selected={head} skin={skin} randomize={() => { randomSlot('head'); }} avatarLoader={avatarLoader} setSlot={setHead} />}
                    {section === 'hair' && <SectionBasic slot='hair' title='Hair' data={data} gender={gender} selected={hair} randomize={() => { randomSlot('hair'); }} avatarLoader={avatarLoader} setSlot={setHair} />}
                    {section === 'top' && <SectionBasic slot='top' title='Top' data={data} gender={gender} selected={top} randomize={() => { randomSlot('top'); }} avatarLoader={avatarLoader} setSlot={setTop} setSecondary={setTopSecondary} />}
                    {section === 'bottom' && <SectionBasic slot='bottom' title='Bottom' data={data} gender={gender} selected={bottom} randomize={() => { randomSlot('bottom'); }} avatarLoader={avatarLoader} setSlot={setBottom} setSecondary={setBottomSecondary} />}
                    {section === 'shoes' && <SectionBasic slot='shoes' title='Shoes' data={data} gender={gender} selected={shoes} randomize={() => { randomSlot('shoes'); }} avatarLoader={avatarLoader} setSlot={setShoes} />}
                </div>
            </div>
        </div>
    )
}
